<template lang='pug'>
a.articleStory-middle(v-if="info.url" :href="info.url")
  .articleStory-left
    .articleStory-image(v-if="info.thumbnailUrl" :style="'background-image: url(' + info.thumbnailUrl + ');'")
    .articleStory-image(v-else-if="info.category && info.category.thumbnailUrl" :style="'background-image: url(' + info.category.thumbnailUrl + ');'")
    .articleStory-image(v-else :style='defaultImg')
  .articleStory-right
    v-clamp.articleStory-description(autoresize :max-lines="3") {{ info.urlContent }}
</template>

<script>
import VClamp from 'vue-clamp'
import { getCategoryImgURL } from '@/plugins/tool.js'
export default {
  components: {
    VClamp
  },
  props: {
    info: Object,
    staticData: Object
  },
  data() {
    return {
      defaultImg: "background-image: url('" + getCategoryImgURL("/fig-link.png") + "');"
    }
  }
}
</script>
